import React, { useState, useEffect } from 'react';
import { PublicPasswordContext } from './PublicPasswordContext';
import PublicPassword from '../services/api/PublicPassword';

const PublicPasswordProvider = (props) => {
    const [isMounted, setIsMounted] = useState(false);
    const [isAuthenticated, setIsAutheticated] = useState(false);
    const [organizationData, setOrganizationData] = useState(false);

    const queryString = require('query-string');
    const params = queryString.parse(window.location.search);
    const path = window.location.pathname.replace(/\//g, '');

    const getStyle = (organizationSetting) => {
        return {
            background: {
                background: organizationSetting.backgroundColor
            },
            header: {
                background: organizationSetting.headerBackgroundColor
            },
            button: {
                background: organizationSetting.buttonColor,
                border: organizationSetting.buttonColor
            },
            link: {
                color: organizationSetting.linkColor
            },
            positionOfLogo: organizationSetting.positionOfLogo,
        };
    }


    useEffect(() => {
        function validateParams () {
            return (params.customerId && params.customerCode && (path === 'aktivera' || path === 'aterstall'))
        }

        function getPublicPassword () {
            if (validateParams()) {
                const publicPasswordApi = new PublicPassword();
                publicPasswordApi.get(params.customerId, params.customerCode, path)
                    .then(response => {
                        if (response.status !== 200) {
                            throw new Error(response.status);
                        }
                        setIsAutheticated(true);
                        return response.json();
                    })
                    .then(data => {
                        setOrganizationData(data);
                        setIsMounted(true);
                    })
                    .catch(error => {
                        setIsMounted(true);
                        console.log(error);
                    });
            } else {
                setIsMounted(true);
            }
        }
        if (!isMounted) {
            getPublicPassword();
        }
    }, [params, path, isMounted]);

    if (isAuthenticated && organizationData && isMounted) {
        return (
            <PublicPasswordContext.Provider
                value={{
                    customerId: params.customerId,
                    customerCode: params.customerCode,
                    path: path,
                    isAuthenticated: isAuthenticated,
                    organizationData: organizationData,
                    style: getStyle(organizationData)
                }}
            >
                {props.children}
            </PublicPasswordContext.Provider>
        )
    } else if (isMounted) {
        return (
            <PublicPasswordContext.Provider
                value={{
                    isAuthenticated: false,
                }}
            >
                {props.children}
            </PublicPasswordContext.Provider>
        );
    }
    return null;
}

const PublicPasswordConsumer = PublicPasswordContext.Consumer

export { PublicPasswordProvider, PublicPasswordConsumer };